/* eslint-disable */

/* globals google */

const deliveryRules = require('site/deliveryrules/deliveryrules');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    let newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map((key) => `${key}=${encodeURIComponent(params[key])}`).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    const infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    const latlng = new google.maps.LatLng(37.09024, -95.712891);
    const mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: latlng,
    };

    const map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    let mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    const bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    // const markerImg = {
    //     path: 'M13.5,30.1460153 L16.8554555,25.5 L20.0024287,25.5 C23.039087,25.5 25.5,'
    //         + '23.0388955 25.5,20.0024287 L25.5,5.99757128 C25.5,2.96091298 23.0388955,0.5 '
    //         + '20.0024287,0.5 L5.99757128,0.5 C2.96091298,0.5 0.5,2.96110446 0.5,5.99757128 '
    //         + 'L0.5,20.0024287 C0.5,23.039087 2.96110446,25.5 5.99757128,25.5 L10.1445445,'
    //         + '25.5 L13.5,30.1460153 Z',
    //     fillColor: '#0070d2',
    //     fillOpacity: 1,
    //     scale: 1.1,
    //     strokeColor: 'white',
    //     strokeWeight: 1,
    //     anchor: new google.maps.Point(13, 30),
    //     labelOrigin: new google.maps.Point(12, 12),
    // };

    if (mapdiv && mapdiv.length !== 0) {
        Object.keys(mapdiv).forEach((key) => {
            const item = mapdiv[key];
            const label = parseInt(key, 10) + 1;
            const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            const marker = new google.maps.Marker({
                position: storeLocation,
                map,
                title: item.name,
                // icon: markerImg,
                label: { text: label.toString(), color: 'white', fontSize: '16px' },
            });

            marker.addListener('click', () => {
                infowindow.setOptions({
                    content: item.infoWindowHtml,
                });
                infowindow.open(map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);
        });
        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        map.fitBounds(bounds);
    }
}

function removeProductInfoFromStoresResults($element) {
    $element.removeData('pids');
    $element.removeData('pid');
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    const $resultsDiv = $('.results');
    const $mapDiv = $('.map-canvas');
    const deliveryUrl = $mapDiv.data('delivery-url');

    const hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);

        $('button.select-store', '.store-locator-container').on('click', (e) => {
            e.preventDefault();
            if ($(this).prop('disabled')) {
                return;
            }

            const selectedStore = $(':checked', '.results-card .results');

            if (selectedStore.length === 0) {
                return;
            }

            const data = {
                storeID: selectedStore.val(),
                storeInfo: selectedStore.data('store-info'),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e,
            };

            if (deliveryUrl) {
                $('#deliveryPickupModal').spinner().start();

                // Check if we're on a PDP and get the product ID
                const isPDP = $('.product-detail').length > 0;
                let ajaxData = {
                    storeID: selectedStore.val(),
                };

                if (isPDP) {
                    // Get delivery options required data and add to ajaxData
                    const deliveryData = deliveryRules.getDeliveryOptionsRequiredData();
                    ajaxData = { ...ajaxData, ...deliveryData };
                }

                if ($('#deliveryPickupModal .results').data('shipmentuuid')) {
                    ajaxData.shipmentUUID = $('#deliveryPickupModal .results').data('shipmentuuid');
                }

                if ($('#deliveryPickupModal .results').data('uuid')) {
                    ajaxData.uuid = $('#deliveryPickupModal .results').data('uuid');
                    ajaxData.deliveryOption = 'pickup';
                }

                $.ajax({
                    url: deliveryUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: ajaxData,
                    success(result) {
                        if (result.success) {
                            $('body').trigger('store:selected', data);

                            if ($('.cart-page').length > 0) {
                                window.location.reload();
                            }
                            $('.delivery-selected-store')
                                .text(data.storeInfo.name)
                                .data('store-info', data.storeInfo)
                                .attr('data-store-info', JSON.stringify(data.storeInfo));

                            if (result.deliveryOptions) {
                                $('body').trigger('delivery:updated', result.deliveryOptions);
                            }

                            $('#deliveryPickupModal').modal('hide');
                        } else {
                            // @TODO: Add error message
                        }
                        $('#deliveryPickupModal').spinner().stop();
                    },
                    error(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        $('#deliveryPickupModal').spinner().stop();
                    },
                });
            } else {
                $('body').trigger('store:selected', data);

                $('.delivery-selected-store').text(data.storeInfo.name);
                $('#deliveryPickupModal').modal('hide');
            }
        });

        $('.select-store-input').on('change', ((e) => {
            const selectedStore = $(':checked', '.results-card .results');
            if (selectedStore.length > 0) {
                $('.select-store', '.store-locator-container').prop('disabled', false);
            }
        }));
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    const dialog = element.closest('#deliveryPickupModal');
    const spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    const $form = element.closest('.store-locator');
    const radius = $('.results').data('radius');
    let url = $form.attr('action');

    const urlParams = {
        radius: radius,
        buttonSelect: $('input[name="isStoreLocator"]').val() === 'true' ? false : true,
        products: getProductId()
    };

    removeProductInfoFromStoresResults($('#deliveryPickupModal .results'));

    const payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success(data) {
            spinner.stop();
            updateStoresResults(data);
        },
    });
    return false;
}

function getProductId() {
    var pid = $('.product-detail:not(".bundle-item")').data('pid');

    if ($('#deliveryPickupModal .results').length > 0) {
        if ($('#deliveryPickupModal .results').data('pids')) {
            return $('#deliveryPickupModal .results').data('pids');
        } else if ($('#deliveryPickupModal .results').data('pid')) {

            var hasQuantity = $('#deliveryPickupModal .results').data('pid').split(':').length > 1;
            if (!hasQuantity) {
                var quantity = $('.quantity-select').val() || '1';

                return $('#deliveryPickupModal .results').data('pid') + ':' + quantity;
            }
            return $('#deliveryPickupModal .results').data('pid');
        }
    }

    return pid ? pid + ':1' : '';
}

module.exports = {
    init() {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    detectLocation() {
        // clicking on detect location.
        $('body').on('click', '.detect-location', () => {
            var $spinner = $('#deliveryPickupModal').length > 0 && $('#deliveryPickupModal').is(':visible')
                ? $('#deliveryPickupModal').spinner()
                : $.spinner();

            $spinner.start();

            if (!navigator.geolocation) {
                $spinner.stop();
                return;
            }

            function success(position) {
                if (!position || !position.coords || !position.coords.latitude || !position.coords.longitude) {
                    console.log("Unable to retrieve location");
                    $spinner.stop();
                    return;
                }
                
                const $detectLocationButton = $('.detect-location');
                let url = $detectLocationButton.data('action');
                const radius = $('.results').data('radius');
                const urlParams = {
                    radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    buttonSelect: $('input[name="isStoreLocator"]').val() === 'true' ? false : true,
                    products: getProductId(),
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url,
                    type: 'get',
                    dataType: 'json',
                    success(data) {
                        $spinner.stop();
                        updateStoresResults(data);
                    },
                });
            }

            function error(errorMsg) {
                console.log("Unable to retrieve location: " + errorMsg);
                $spinner.stop();
            }

            navigator.geolocation.getCurrentPosition(success, error);
        });
    },

    search() {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });

        $('#store-postal-code').keypress(function (e) {
            if (e.which == 13) {
                $('.store-locator-container .btn-storelocator-search[type="button"]').trigger('click');
                return false;
            }
          });
    },

    changeRadius() {
        $('.store-locator-container .radius').change(function () {
            const radius = $(this).val();
            const searchKeys = $('.results').data('search-key');
            let url = $(this).data('action-url');
            let urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius,
                    postalCode: searchKeys.postalCode,
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long,
                };
            }

            urlParams.buttonSelect = true;

            url = appendToUrl(url, urlParams);
            const dialog = $(this).closest('.in-store-inventory-dialog');
            const spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                success(data) {
                    spinner.stop();
                    updateStoresResults(data);
                },
            });
        });
    },
    selectStore() {
        $('.store-locator-container').on('click', '.select-store', ((e) => {
            e.preventDefault();

            let inputRadio = $(e.target).parents('.form-check').find(':radio');
            inputRadio.prop('checked', true);

            const selectedStore = $(':checked', '.results-card .results');
            const data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e,
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton() {
        $('body').on('change', '.select-store-input', (() => {
            //$('.select-store').prop('disabled', false);
        }));
    },
};
